import React from "react";
import { CountryModel } from "../../../shared/models/countryModel";
import { Grid } from "@mui/material";
import BarekamText from "../../../components/text";
import { ShippingInfoModel } from "../../../shared/models/order/shipping-info.model";
import { WarehouseModel } from "../../../shared/models/order/warehouse.model";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { onWarehouseChange } from "../../../../services/orders.service";
import { OrderPopupCardTitle } from "../styled";
import { SingleWarehouse } from "../../../components/single-warehouse/single-warehouse";
import { CountrySelectorContainer } from "./styled";
import { CurrencyModel } from "../../../../redux/reducers/static-data.reducers";

export const OrderPopupCountries = (props: CountriesProps) => {
    const { shippingInfo } = props;

    const { countries } = useAppSelector(state => state.staticDataReducer);
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const warehouseId = shippingInfo?.warehouse?.warehouseId || 1;

    const dispatch = useAppDispatch();

    const Countries = () => (
        <Grid container rowGap={'1rem'}>
            {countries.map(country =>
                country && country.isAllowedExport && country?.hasActiveWarehouse ?
                    country.warehouse.map(warehouse =>
                        <Grid item xs={matchesPhone ? 12 : 6}
                            key={country.countryId} display={'flex'}>
                            <SingleWarehouse selected={warehouseId === warehouse.warehouseId}
                                warehouse={warehouse}
                                country={country}
                                size={'m'}
                                onChange={(warehouse: WarehouseModel, country: CountryModel, currencies: CurrencyModel[]) => onWarehouseChange(warehouse, country, currencies, dispatch)}
                                key={country.countryId} />
                        </Grid>
                    ) : ''
            )}
        </Grid>
    )

    return (
        <CountrySelectorContainer>
            <OrderPopupCardTitle>
                <BarekamText variant={'m'}>
                    <Message messageKey={'new_order_country'} sectionId={MessageSections.ORDERS} />
                </BarekamText>

                <BarekamText variant={'s'} opaque>
                    <Message messageKey={'new_order_country_hint'} sectionId={MessageSections.ORDERS} />
                </BarekamText>
            </OrderPopupCardTitle>

            <Countries />
        </CountrySelectorContainer>
    );
}

interface CountriesProps {
    shippingInfo?: ShippingInfoModel,
    selectedWarehouseId?: number;
    selectedCountryId?: number;
}
